import {
  BannerOutdoorDesktop,
  BannerOutdoorMobile,
  BannerOutdoorTablet,
  BannerRtlsDesktop,
  BannerRtlsMobile,
  BannerRtlsTablet,
  BannerVideoDesktop,
  BannerVideoMobile,
  BannerVideoTablet,
  HomeAccess1D,
  HomeAccess1M,
  HomeAccess1T,
  HomeAccess2D,
  HomeAccess2M,
  HomeAccess2T,
  HomeAccess3D,
  HomeAccess3M,
  HomeAccess3T,
  HomeAccess4D,
  HomeAccess4M,
  HomeAccess4T,
  HomeAccess5D,
  HomeAccess5M,
  HomeAccess5T,
  HomeBeacon1D,
  HomeBeacon1M,
  HomeBeacon1T,
  HomeBeacon2D,
  HomeBeacon2M,
  HomeBeacon2T,
  HomeBeacon3D,
  HomeBeacon3M,
  HomeBeacon3T,
  HomeBeacon4D,
  HomeBeacon4M,
  HomeBeacon4T,
  HomeBeacon5D,
  HomeBeacon5M,
  HomeBeacon5T,
  HomeBeacon6D,
  HomeBeacon6M,
  HomeBeacon6T,
  HomeProductAoaDesktop,
  HomeProductAoaMobile,
  HomeProductAoaTablet,
  HomeProductBleDesktop,
  HomeProductBleMobile,
  HomeProductBleTablet,
  HomeProductComfortDesktop,
  HomeProductComfortMobile,
  HomeProductComfortTablet,
  HomeProductEdgeDesktop,
  HomeProductEdgeMobile,
  HomeProductEdgeTablet,
  HomeProductServerDesktop,
  HomeProductServerMobile,
  HomeProductServerTablet,
  HomeProductUwbDesktop,
  HomeProductUwbMobile,
  HomeProductUwbTablet,
  HomeRTLS1D,
  HomeRTLS1M,
  HomeRTLS1T,
  HomeRTLS2D,
  HomeRTLS2M,
  HomeRTLS2T,
  HomeRTLS3D,
  HomeRTLS3M,
  HomeRTLS3T,
  HomeSolution1D,
  HomeSolution1M,
  HomeSolution1T,
  HomeSolution2D,
  HomeSolution2M,
  HomeSolution2T,
  HomeSolution3D,
  HomeSolution3M,
  HomeSolution3T,
  HomeSolution4D,
  HomeSolution4M,
  HomeSolution4T,
  HomeSolutionLandConstruction,
  HomeSolutionLandLogistics,
  HomeSolutionLandManufacture,
  HomeSolutionLandMedical,
  HomeSolutionLandOffice,
  HomeSolutionLandRetail,
  HomeSolutionPortConstruction,
  HomeSolutionPortLogistics,
  HomeSolutionPortManufacture,
  HomeSolutionPortMedical,
  HomeSolutionPortOffice,
  HomeSolutionPortRetail,
} from '@assets/images/main/home';
import { HomeDTBanner } from '@assets/images/main/home/dt';

export default {
  titleBanner: {
    title: '定位追踪与数字孪生专业平台',
    description: '通过实时定位、出入控制、数字孪生和工业物联网带来空间革新',
  },

  productText: {
    title: '数字孪生与定位追踪产品',
    description: 'ORBRO为追求变化的您带来全新提案',
  },

  banner: {
    productCard: [
      {
        title: '室内定位追踪',
        desc: '基于BLE、AoA、UWB等无线通信技术的定位追踪',
        link: '',
        bgImg: {
          desktop: BannerRtlsDesktop,
          tablet: BannerRtlsTablet,
          mobile: BannerRtlsMobile,
        },
      },
      {
        title: '视频定位追踪',
        desc: '基于AI的视频对象追踪技术',
        link: '',
        bgImg: {
          desktop: BannerVideoDesktop,
          tablet: BannerVideoTablet,
          mobile: BannerVideoMobile,
        },
      },
      {
        title: '室外定位追踪',
        desc: '对车辆和场地进行位置追踪',
        link: '',
        bgImg: {
          desktop: BannerOutdoorDesktop,
          tablet: BannerOutdoorTablet,
          mobile: BannerOutdoorMobile,
        },
      },
    ],
  },

  products: {
    title: '高精度无线追踪，ORBRO 射频解决方案',
    desc: '通过 BLE、UWB 和 AoA 技术获取实时定位数据',
    button: '咨询合作',
    buttonLink: 'https://orbro.io/request',
    card: [
      {
        title: 'TwinTracker BLE',
        desc: '基于低功耗BLE信号，经济高效地追踪室内外资产、人员与车辆位置。',
        link: '/cn/rtls/ble',
        img: {
          desktop: HomeProductBleDesktop,
          tablet: HomeProductBleTablet,
          mobile: HomeProductBleMobile,
        },
      },
      {
        title: 'TwinTracker AoA',
        desc: '通过计算BLE信号的到达角（AoA），提供高精度定位数据。',
        link: '/cn/rtls/aoa',
        img: {
          desktop: HomeProductAoaDesktop,
          tablet: HomeProductAoaTablet,
          mobile: HomeProductAoaMobile,
        },
      },
      {
        title: 'TwinTracker UWB',
        desc: '采用UWB超宽带技术，实现实时高精度定位追踪。',
        link: '/cn/rtls/uwb',
        img: {
          desktop: HomeProductUwbDesktop,
          tablet: HomeProductUwbTablet,
          mobile: HomeProductUwbMobile,
        },
      },
      {
        title: 'Comfort Kit',
        desc: '无需服务器，仅通过手机App即可轻松使用的独立BLE追踪系统。',
        link: '/cn/rtls/comfort',
        img: {
          desktop: HomeProductComfortDesktop,
          tablet: HomeProductComfortTablet,
          mobile: HomeProductComfortMobile,
        },
      },
    ],
  },

  camera: {
    title: '基于视频的定位追踪',
    desc: '通过AI视频分析技术，实时追踪人、车辆、物体的位置。',
    card: [
      {
        title: 'ORBRO Edge AI',
        desc: '适用于小规模部署的Edge设备（支持最多2台摄像头）',
        link: '/cn/camera/edge',
        img: {
          desktop: HomeProductEdgeDesktop,
          tablet: HomeProductEdgeTablet,
          mobile: HomeProductEdgeMobile,
        },
      },
      {
        title: 'ORBRO AI Server',
        desc: '支持大规模多摄像头接入（适用于企业环境）',
        link: '/cn/camera/server',
        img: {
          desktop: HomeProductServerDesktop,
          tablet: HomeProductServerTablet,
          mobile: HomeProductServerMobile,
        },
      },
    ],
  },

  faq: {
    title: '常见问题',
    list: [
      {
        q: 'ORBRO 定位追踪解决方案可以用于室内外吗？',
        a: '可以，适用于室内外环境。\n支持BLE、UWB、AoA等无线方式，AI视频分析方式，以及GPS（用于车辆或场地终端）。',
      },
      {
        q: '无线定位与视频定位的区别是什么？',
        a: '无线定位通过BLE、UWB、AoA等信号计算精确位置。\n视频定位则利用AI分析摄像画面，实时识别人、车辆的位置。\n可根据需求组合使用两种方式。',
      },
      {
        q: '部署 ORBRO 产品需要服务器或额外设备吗？',
        a: '取决于产品类型。\nComfort Kit无需服务器，仅需App即可使用。\nTwinTracker（BLE/UWB/AoA）需配合 ORBRO Server 或 Edge设备使用。\n视频定位（Edge AI/AI Server）需安装摄像头并连接服务器。',
      },
      {
        q: '是否可以部署于小型空间？',
        a: '当然可以。Comfort Kit与ORBRO Edge AI适用于办公室、仓库、临时工地等小型场所。\n我们将根据实际环境推荐最合适方案。',
      },
      {
        q: '定位数据可以如何使用？',
        a: '通过 ORBRO OS 可实时查看地图位置，\n也可通过API接入客户系统，用于资产管理、人员监控、安全管控等多种应用。',
      },
      {
        q: '安装 ORBRO 产品需要多长时间？',
        a: 'Comfort Kit数小时内可启用，\nTwinTracker及视频系统根据现场规模一般在数天至数周内完成安装。',
      },
      {
        q: '可以只在内网中运行，不上传数据到外部服务器吗？',
        a: '可以。\n可将 ORBRO Server 或 AI Server 部署在本地局域网中，无需连接外网即可安全运行。',
      },
      {
        q: 'ORBRO 解决方案是否具有扩展性？',
        a: '是的。\n可根据现场需求扩展传感器、摄像头、系统功能，并支持API对接第三方平台。',
      },
      {
        q: '部署后如何进行系统维护？',
        a: '初期安装后将提供基础维护服务，\n如需定期检查或技术支持，也可通过单独合同提供专业服务。',
      },
    ],
  },

  os: {
    title: '最了解空间的软件',
    desc: 'Orbro OS利用最新的通信技术，<br/>实时准确地追踪和管理空间中的所有元素。',
  },

  rtls: {
    title: '适用于所有场景的定位追踪阵容',
    desc: '提供利用蓝牙、UWB通信的无线电定位追踪和利用视频与AI技术的定位追踪阵容。',

    card: [
      {
        tag: '实时位置追踪',
        title: '在虚拟空间中呈现现实',
        link: 'https://orbro.io/cn/rtls',
        img: {
          desktop: HomeRTLS1D,
          tablet: HomeRTLS1T,
          mobile: HomeRTLS1M,
        },
      },
      {
        title: '通过Beacon定位追踪',
        desc: '通过BLE的定位追踪系统',
        link: 'https://orbro.io/cn/beacon/ble',
        img: {
          desktop: HomeRTLS2D,
          tablet: HomeRTLS2T,
          mobile: HomeRTLS2M,
        },
      },
      {
        title: '通过AI摄像头定位追踪',
        desc: '利用AI技术的定位追踪及异常行为检测',
        link: 'https://orbro.io/cn/camera',
        img: {
          desktop: HomeRTLS3D,
          tablet: HomeRTLS3T,
          mobile: HomeRTLS3M,
        },
      },
    ],
  },

  access: {
    title: '利用手机实现自然的非接触出入',
    desc: '提供利用手机、面部识别技术的下一代出入方式和信息。',

    card: [
      {
        tag: '提供多种出入方式',
        title: 'NFC/蓝牙/智能手机<br/>所有方式的出入',
        sub: '不仅支持NFC卡出入，<br/>还支持手机出入、智能手表出入。',
        img: {
          desktop: HomeAccess1D,
          tablet: HomeAccess1T,
          mobile: HomeAccess1M,
        },
      },
      {
        title: 'Access Pro',
        link: 'https://orbro.io/cn/access/pro',
        desc: '支持面部识别、NFC卡、手机所有出入方式',
        img: {
          desktop: HomeAccess2D,
          tablet: HomeAccess2T,
          mobile: HomeAccess2M,
        },
      },
      {
        title: 'Access Auto',
        link: 'https://orbro.io/cn/access/auto',
        desc: '手机出入的最佳优化',
        img: {
          desktop: HomeAccess3D,
          tablet: HomeAccess3T,
          mobile: HomeAccess3M,
        },
      },
      {
        title: '配件',
        desc: '提供多种出入配件',
        link: 'https://orbro.io/cn/access/accessory',
        img: {
          desktop: HomeAccess4D,
          tablet: HomeAccess4T,
          mobile: HomeAccess4M,
        },
      },
      {
        title: 'Access Lite',
        desc: '专注基础的手机出入系统，支持NFC和Apple Watch',
        tag: '即将发布',
        img: {
          desktop: HomeAccess5D,
          tablet: HomeAccess5T,
          mobile: HomeAccess5M,
        },
      },
    ],
  },

  dt: {
    title: '全球首创第三代数字转型<br/>数字孪生专业平台',
    desc: '通过Orbro的数字孪生解决方案虚拟实现城市，体验更加进化的创新。',
    img: HomeDTBanner,
  },

  beacon: {
    title: '工业物联网及Beacon系统',
    desc: '通过满足工业现场需求的多种传感器及Beacon系统，打造高效的工作环境。',

    card: [
      {
        title: 'ALESS-GW',
        desc: 'LoRA中继器',
        link: 'https://orbro.io/cn/iot/LoRAGateway',
        img: {
          desktop: HomeBeacon1D,
          tablet: HomeBeacon1T,
          mobile: HomeBeacon1M,
        },
      },
      {
        title: 'ALESS-BA',
        desc: '利用LoRA通信的工业传感器',
        link: 'https://orbro.io/cn/iot/LoRASensor',
        img: {
          desktop: HomeBeacon2D,
          tablet: HomeBeacon2T,
          mobile: HomeBeacon2M,
        },
      },
      {
        title: 'VENTAX CO+',
        desc: '一氧化碳检测器',
        link: 'https://orbro.io/cn/iot/co2',
        img: {
          desktop: HomeBeacon3D,
          tablet: HomeBeacon3T,
          mobile: HomeBeacon3M,
        },
      },
      {
        title: 'VENTAX',
        desc: '空气质量检测器',
        link: 'https://orbro.io/cn/iot/air',
        img: {
          desktop: HomeBeacon4D,
          tablet: HomeBeacon4T,
          mobile: HomeBeacon4M,
        },
      },
      {
        title: 'Plutocon Pro',
        desc: '工业用Beacon终端',
        link: 'https://orbro.io/cn/beacon/industry',
        img: {
          desktop: HomeBeacon5D,
          tablet: HomeBeacon5T,
          mobile: HomeBeacon5M,
        },
      },
      {
        title: 'ORBRO Tag',
        desc: '小型Beacon终端',
        link: 'https://orbro.io/cn/beacon/tag',
        img: {
          desktop: HomeBeacon6D,
          tablet: HomeBeacon6T,
          mobile: HomeBeacon6M,
        },
      },
    ],
  },

  solution: {
    title: '位置追踪与数字孪生的融合',
    desc: '在建筑、物流、制造、医疗等多个行业中，体验Orbro的先进解决方案。',
    button: '咨询',
    buttonLink: 'https://orbro.io/cn/request',
    card: [
      {
        title: '建筑',
        desc: '建筑工地安全管理、库存管理等，让建筑工地智能化转变。',
        link: 'https://orbro.io/cn/enterprise/construction/safety',
        img: {
          desktop: HomeSolution1D,
          tablet: HomeSolution1T,
          mobile: HomeSolution1M,
        },
      },
      {
        title: '物流',
        desc: '在大型物流中心和仓库中，实时掌握库存位置及工作人员安全管理。',
        link: 'https://orbro.io/cn/enterprise/logistics/asset',
        img: {
          desktop: HomeSolution2D,
          tablet: HomeSolution2T,
          mobile: HomeSolution2M,
        },
      },
      {
        title: '制造',
        desc: '实时管理制造过程，提高库存管理和生产效率。',
        link: 'https://orbro.io/cn/enterprise/manufacturing/process',
        img: {
          desktop: HomeSolution3D,
          tablet: HomeSolution3T,
          mobile: HomeSolution3M,
        },
      },
      {
        title: '医疗',
        desc: '在医院和医疗设施中追踪和管理患者，保障安全。',
        link: 'https://orbro.io/cn/enterprise/medical/patient',
        img: {
          desktop: HomeSolution4D,
          tablet: HomeSolution4T,
          mobile: HomeSolution4M,
        },
      },
    ],
  },

  //product.ts
  product: {
    items: [
      {
        title: '无线位置追踪',
        description: '通过无线位置追踪<br/>实现完美的资产管理和准确的定位追踪',
        link: '/cn/rtls',
      },

      {
        title: '摄像头位置追踪',
        description: `利用AI技术的摄像头位置追踪系统`,
        link: '/cn/camera',
      },

      {
        title: '出入系统',
        description: '更快，更智能。<br/>新的出入系统',
        link: '/cn/access',
      },
      {
        title: '工业传感器',
        description: '从火灾检测到温湿度<br/>可立即应用于现场的传感器',
        link: '/cn/iot/LoRAGateway',
      },
      {
        title: '物联网（IoT）',
        description: `从简单中带来特别的变化`,
        link: '/cn/iot/bell',
      },
      {
        title: 'Beacon终端',
        description: '完善的Beacon系统',
        link: '/cn/beacon/industry',
      },
    ],
  },

  control: {
    title: `通过ORBRO进行综合管理`,
    description: `一个软件<br/>从移动设备到桌面，您所需的一切简化`,
  },
  showMore: '了解更多',
};
